import Notifications from '@/pages/Notifications'

export default {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications
}


// WEBPACK FOOTER //
// ./src/router/notifications.js